import { ADMIN_API } from "./adminApi";
import { ApiOk, Paginated } from "./adminCommon.types";

export type AdminEnvioFilters = {
  page?: number;
  limit?: number;
  cliente_id?: string | number;
  carrier?: string;
  status?: string;
  pais?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
};

export const listAdminEnvios = async (filters: AdminEnvioFilters = {}) => {
  const { data } = await ADMIN_API.get<Paginated<any>>("/api/admin/envios", { params: filters });
  return data;
};

export const getAdminEnvioDetail = async (id: string | number) => {
  const { data } = await ADMIN_API.get<ApiOk<any>>(`/api/admin/envios/${id}`);
  return data.data;
};

/*
 * Correção da invoice depois de emitida.
 *
 * Os ajustes não tocam em `pedido`: o preço do item também alimenta a
 * estimativa de imposto, a cotação das transportadoras e o formulário CPSC.
 * A correção fica guardada à parte e a invoice é gerada a partir de
 * pedido + ajustes, então o valor declarado na emissão continua legível.
 *
 * Campo deixado em branco quer dizer "não mexer", e não "zerar".
 */
export type AjusteItemInvoice = {
  indice: number;
  preco?: number | string;
  qty?: number | string;
  descricao?: string;
  hscode?: string;
  pesoUnit?: number | string;
  countryOfOrigin?: string;
};

export type MudancaInvoice = {
  indice: number;
  campo: string;
  de: string | number | null;
  para: string | number;
};

export type ReemissaoInvoice = {
  cotacao_id: number;
  mudancas: MudancaInvoice[];
  /** 'INTREX' se o PDF substituído foi gerado por nós; null se veio da transportadora ou é antigo. */
  origem_anterior: string | null;
  invoice_path: string;
};

export const reemitirInvoiceAjustada = async (
  id: string | number,
  payload: { itens: AjusteItemInvoice[]; motivo: string }
) => {
  const { data } = await ADMIN_API.post<ApiOk<ReemissaoInvoice>>(
    `/api/admin/envios/${id}/invoice/reemitir`,
    payload
  );
  return data as unknown as ReemissaoInvoice & { ok: boolean };
};

export const baixarInvoiceAdmin = async (id: string | number) => {
  const resp = await ADMIN_API.get(`/api/admin/envios/${id}/invoice`, {
    responseType: "blob",
  });
  return resp.data as Blob;
};

export const buscarEnvioPorRastreio = async (tracking: string) => {
  const { data } = await ADMIN_API.get<ApiOk<any[]>>(
    `/api/admin/envios/rastreio/${encodeURIComponent(tracking)}`
  );
  return data.data;
};

export type ReconciliacaoLinha = {
  tracking: string;
  encontrado: boolean;
  duplicado: boolean;
  clienteId: number | null;
  cliente: string | null;
  pedidoRef: string | null;
  carrier: string | null;
  status: string | null;
  valorUsd: number | null;
  valorBrl: number | null;
  data: string | null;
};

export type ReconciliacaoResumo = {
  clienteId: number;
  cliente: string | null;
  envios: number;
  totalUsd: number;
  valorBrl: number | null;
};

export type ReconciliacaoResultado = {
  linhas: ReconciliacaoLinha[];
  resumo: ReconciliacaoResumo[];
  totalInformados: number;
  totalEncontrados: number;
  dolar: number | null;
};

export const reconciliarRastreios = async (trackings: string[]) => {
  const { data } = await ADMIN_API.post<ApiOk<ReconciliacaoResultado>>("/api/admin/envios/reconciliar", {
    trackings,
  });
  return data.data;
};
